import types from '../../constants';

export function end(id) {
  return async (dispatch) => {
    global.socket.emit('exercise_delete', { id });
    dispatch({ type: types.SOCKET_ACTION });
  };
}

export function showHideVariables(value) {
  return {
    type: types.EXERCISE_RUN_SHOW_VARIABLES,
    payload: value,
  };
}
